<template>
	<div id="app">
		<div class="main">
			<navigation />

			<div class="main-container">
				<router-view />
			</div>

		</div>
		<custom-footer />

	</div>

</template>

<style lang="css" scoped>
	/* @import '~bootstrap/dist/css/bootstrap.min.css'; */
	/* @import './assets/css/main.css'; */
</style>

<script>
	import Navigation from 'components/00-navigation';
	import { mapGetters, mapState } from 'vuex';
	import { USER_REQUEST } from 'actions/user';
	import { POPUP_REQUEST } from 'actions/user';
	import CustomFooter from './components/01-footer/index.vue';
	import './assets/scss/main.scss';

	export default {
		components: {
			CustomFooter,
			Navigation,
			//loading,
		},
		data() {
			return {
				metaTitle: 'Aperitivo con Aperol',
				metaDesc: 'In palio fantastici premi!',
				metaImg: '',
				popUpCheckAge:
					process.env.VUE_APP_HAS_CHECKAGE_POPUP == 'ON' ? true : false,
			};
		},
		name: 'app',
		methods: {
			addRelayTags() {
				let data = {
					brand: process.env.VUE_APP_RELAY_NAME,
					timeStamp: +new Date(),
					url: location.href,
					'referrer-url': document.referrer,
					userAgent: window.navigator.userAgent,
					'Contest Consent': 'Y',
					'Marketing Consent': this.getProfile.agreement1_player ? 'Y' : 'N',
					'Profiling Consent': this.getProfile.agreement2_player ? 'Y' : 'N',
					'Third Party Consent': this.getProfile.agreement3_player ? 'Y' : 'N',
				};

				_st('addTagProperties', data);

				let localData = {
					email: this.getProfile.username_player,
					name: this.getProfile.first_name_player,
					lastname: this.getProfile.last_name_player,
				};

				_st('addLocalTagProperties', localData);
				_st('publishEvent', 'submit', 'Account');
				_st('publishEvent', 'consent', 'setConsent');
				_st('loadTags');
			},
		},
		created: async function () {
			if (this.$store.getters.getPopup.status == false) {
				this.$track('getPopup', 'popup Loading');

				this.$store.dispatch(POPUP_REQUEST);
			} else {
				this.$track('getPopup', 'popup already Load');
			}

			if (this.$store.getters.isAuthenticated) {
				await this.$store.dispatch(USER_REQUEST);

				this.addRelayTags();
			}
		},
		watch: {
			$route: function () {},
		},
		computed: {
			...mapGetters([
				'getProfile',
				'isAuthenticated',
				'loadingState',
				'authStatus',
				'acceptRelay42',
			]),
		},
	};
</script> 
